<template>
    <BreadCrumb PageTitle="Ajouter un montant" />
    <AddMontant />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddMontant from "../../components/Montant/AddMontant.vue";
  
    export default defineComponent({
      name: "AddMontantPage",
      components: {
        BreadCrumb,
        AddMontant,
      },
    });
  </script>